import { render, staticRenderFns } from "./IconReceiptTaxSolid.vue?vue&type=template&id=314956c0"
import script from "./IconReceiptTaxSolid.vue?vue&type=script&lang=js"
export * from "./IconReceiptTaxSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports